import React, { useCallback, useMemo, useState } from 'react';
import { TiLocation } from 'react-icons/ti';

import {
  Container,
  SpanRow,
  List,
  ListItem,
  Badge,
  BadgeIcon,
  BadgeContent,
  BadgeTitle,
  BadgeDescription,
  Divider,
  Row,
  Column,
  VehicleArea,
  BadgeArea,
  ScoreLocation,
  BadgeAreaTitle,
} from './styles';

import Cautelar from '../../../../images/icons/badge_cautelar_aprovada.svg';
import CautelarInstaCarro from '../../../../images/icons/badge_instacarro_cautelar_aprovada.svg';
import Km from '../../../../images/icons/km.svg';
import Margem from './images/margem.svg';
import Giro from './images/giro.svg';
import Longarina from '../../../../images/icons/badge_longarina.svg';
import Colunas from '../../../../images/icons/badge_colunas.svg';
import Cambio from '../../../../images/icons/badge_cambio.svg';
import Scanner from '../../../../images/icons/badge_scanner.svg';
import UberRJ from '../../../../images/icons/badge_uber_rj.svg';
import UberSP from '../../../../images/icons/badge_uber_sp.svg';
import Uber from '../../../../images/icons/badge_uber.svg';
import Pneus from '../../../../images/icons/badge_bom_km.svg';
import BadgePneus from '../../../../images/icons/badge_pneus.svg'; // Novo ícone para pneus
import BadgeInterior from '../../../../images/icons/badge_interior.svg'; // Novo ícone para conservação do interior
import BadgeGNV from '../../../../images/icons/badge_gnv.svg'; // Novo ícone para GNV
import BadgeBlindagem from '../../../../images/icons/badge_blindagem.svg'; // Novo ícone para blindagem
import BadgeMotor from '../../../../images/icons/badge_motor.svg'; // Badge de motor sem apontamentos

import { ReferencePrices } from '../ReferencePrices';
import { useFlag } from '@unleash/proxy-client-react';
import MaximumQuality from '../MaximumQuality';
import { DocumentResearch } from '../DocumentResearch';
import { DutLabel } from './styles';

const fuel = [
  'GASOLINA',
  'FLEX',
  'ETANOL',
  'DIESEL',
  'HIBRIDO',
  'HYBRID',
  'ELETRICO',
  'GASOLINA/GNV',
  'GASOLINA/ETANOL',
  'GASOLINA/ETANOL/GNV',
  'GASOLINA/ELETRICO',
  'GASOLINA/ETANOL/ELETRICO',
  'HYBRID FLEX',
  'HIBRIDO FLEX',
  'JETFLEX GASOLINA',
];

export const SummaryD2D = props => {
  const { auction, summary, marketPrice, updatedAuction } = props;
  const shouldShowFipeWebPrices = useFlag('ref-fipe-web-prices');

  const [size, setSize] = useState(window.screen.width);

  /** BADGEs UNLEASH FLAGS */
  const flagBadgeCautelar = useFlag('badge-cautelar');
  const flagBadgeLongarina = useFlag('badge-longarina');
  const flagBadgeColunas = useFlag('badge-colunas');
  const flagBadgeKm = useFlag('badge-km');
  const flagBadgeCambio = useFlag('badge-cambio');
  const flagBadgeScanner = useFlag('badge-scanner');
  const flagBadgeMargem = useFlag('badge-margem');
  const flagBadgeRevenda = useFlag('badge-giro');
  const flagBadgeUberSP = useFlag('badge-uber-sp');
  const flagBadgeUberRJ = useFlag('badge-uber-rj');
  const flagBadgeUberBoothStates = useFlag('badge-uber');
  const flagBadgePneus = useFlag('badge-pneus'); // Nova flag para badge de pneus
  const flagBadgeInterior = useFlag('badge-interior'); // Nova flag para badge de conservação do interior
  const flagBadgeGNV = useFlag('badge-gnv'); // Nova flag para badge de GNV
  const flagBadgeBlindagem = useFlag('badge-blindagem');

  const formmatDescription = description => {
    const parts = description.split(':');
    return parts.length >= 2 ? parts[1].trim() : '';
  };

  const injuctionNote = useMemo(
    () =>
      `Laudo Cautelar: ${updatedAuction?.summary?.additionalInfo?.precautionaryStatus ||
        'Não informado'}`,
    [updatedAuction]
  );

  const keySet = summary?.evaluation?.highlights?.map(({ icon, description }) =>
    icon === 12 ? formmatDescription(description) : null
  );

  const manualBooklet = summary?.evaluation?.highlights?.map(({ icon, description }) =>
    icon === 13 ? formmatDescription(description) : null
  );

  // Para D2D, os dados do vehicle podem estar em updatedAuction?.vehicle (nível raiz) ou em summary
  // Usar vehicle primeiro, depois summary como fallback (como no EvaluationBadges)
  const vehicle = updatedAuction?.vehicle || auction?.vehicle;
  const vehicleData = vehicle || summary || {};
  const isD2D = summary?.hasD2D || false;

  // Para D2D, verificar também o status da cautelar em summary.additionalInfo
  const hasPrecautionaryReport =
    vehicleData?.precautionaryReport ||
    summary?.precautionaryReport ||
    (summary?.additionalInfo?.precautionaryStatus &&
      String(summary.additionalInfo.precautionaryStatus)
        .toLowerCase()
        .includes('aprovad'));

  // Para D2D, ignorar flags do Unleash - mostrar badges baseado apenas nos dados
  const shouldShowBadgeUberBoothStates = isD2D
    ? (vehicleData?.canHaveUberSPBadge || summary?.canHaveUberSPBadge) &&
      (vehicleData?.canHaveUberRJBadge || summary?.canHaveUberRJBadge)
    : (vehicleData?.canHaveUberSPBadge || summary?.canHaveUberSPBadge) &&
      (vehicleData?.canHaveUberRJBadge || summary?.canHaveUberRJBadge) &&
      flagBadgeUberBoothStates;

  const shouldShowBadgeUberSP = isD2D
    ? (vehicleData?.canHaveUberSPBadge || summary?.canHaveUberSPBadge) &&
      !shouldShowBadgeUberBoothStates
    : (vehicleData?.canHaveUberSPBadge || summary?.canHaveUberSPBadge) &&
      flagBadgeUberSP &&
      !shouldShowBadgeUberBoothStates;

  const shouldShowBadgeUberRJ = isD2D
    ? (vehicleData?.canHaveUberRJBadge || summary?.canHaveUberRJBadge) &&
      !shouldShowBadgeUberBoothStates
    : (vehicleData?.canHaveUberRJBadge || summary?.canHaveUberRJBadge) &&
      flagBadgeUberRJ &&
      !shouldShowBadgeUberBoothStates;

  const shouldShowCautelar = isD2D
    ? hasPrecautionaryReport
    : hasPrecautionaryReport && flagBadgeCautelar;

  const shouldShowLongarina = isD2D
    ? (vehicleData?.canHaveCarSparBadge || summary?.canHaveCarSparBadge) && !shouldShowCautelar
    : (vehicleData?.canHaveCarSparBadge || summary?.canHaveCarSparBadge) &&
      flagBadgeLongarina &&
      !shouldShowCautelar;

  const shouldShowColunas = isD2D
    ? (vehicleData?.canHaveColumnBadge || summary?.canHaveColumnBadge) && !shouldShowCautelar
    : (vehicleData?.canHaveColumnBadge || summary?.canHaveColumnBadge) &&
      flagBadgeColunas &&
      !shouldShowCautelar;

  // Nova lógica para badge de pneus
  const shouldShowPneus = isD2D
    ? vehicleData?.canHaveTiresBadge || summary?.canHaveTiresBadge
    : (vehicleData?.canHaveTiresBadge || summary?.canHaveTiresBadge) && flagBadgePneus;

  // Nova lógica para badge de conservação do interior
  const shouldShowInterior = isD2D
    ? vehicleData?.canHaveInteriorBadge || summary?.canHaveInteriorBadge
    : (vehicleData?.canHaveInteriorBadge || summary?.canHaveInteriorBadge) && flagBadgeInterior;

  // Nova lógica para badge de GNV
  // Para D2D, também verificar se summary ou version contém "GNV"
  const hasGNVInSummary =
    (summary?.summary &&
      String(summary.summary)
        .toUpperCase()
        .includes('GNV')) ||
    (summary?.version &&
      String(summary.version)
        .toUpperCase()
        .includes('GNV')) ||
    (vehicleData?.summary &&
      String(vehicleData.summary)
        .toUpperCase()
        .includes('GNV')) ||
    (vehicleData?.version &&
      String(vehicleData.version)
        .toUpperCase()
        .includes('GNV'));

  const shouldShowGNV = isD2D
    ? vehicleData?.canHaveGNVBadge || summary?.canHaveGNVBadge || hasGNVInSummary
    : (vehicleData?.canHaveGNVBadge || summary?.canHaveGNVBadge) && flagBadgeGNV;

  const shouldShowBlindagem = isD2D
    ? vehicleData?.canHaveBlindagemBadge || summary?.canHaveBlindagemBadge
    : (vehicleData?.canHaveBlindagemBadge || summary?.canHaveBlindagemBadge) && flagBadgeBlindagem;

  // Lógica para badge de motor sem apontamentos
  const shouldShowMotor = isD2D
    ? vehicleData?.canHaveEngineBadge || summary?.canHaveEngineBadge
    : vehicleData?.canHaveEngineBadge || summary?.canHaveEngineBadge;

  // Para D2D, apenas essas badges são permitidas:
  // - badgeCautelar (precautionaryReport)
  // - badgeCambioSemApontamento (canHaveTransmissionBadge)
  // - badgeGNV (canHaveGNVBadge)
  // - badgeBlindagem (canHaveBlindagemBadge)
  const BADGE_STATUS = {
    BadgeCautelar: shouldShowCautelar,
    BadgeLongarina: isD2D ? false : shouldShowLongarina, // Desabilitado para D2D
    BadgeColunas: isD2D ? false : shouldShowColunas, // Desabilitado para D2D
    BadgeBomKm: isD2D
      ? false // Desabilitado para D2D
      : (vehicleData?.kilometrageAcceptable || summary?.kilometrageAcceptable) && flagBadgeKm,
    BadgeCambio: isD2D
      ? vehicleData?.canHaveTransmissionBadge || summary?.canHaveTransmissionBadge
      : (vehicleData?.canHaveTransmissionBadge || summary?.canHaveTransmissionBadge) &&
        flagBadgeCambio,
    BadgeScanner: isD2D
      ? false // Desabilitado para D2D (badgeMecanica pode ser apenas cambio)
      : (vehicleData?.canHaveScannerBadge || summary?.canHaveScannerBadge) && flagBadgeScanner,
    BadgeMargem: isD2D
      ? false // Desabilitado para D2D
      : (vehicleData?.isBelowThreshold || summary?.isBelowThreshold) && flagBadgeMargem,
    BadgeRevenda: isD2D
      ? false // Desabilitado para D2D
      : (vehicleData?.fastSpin || summary?.fastSpin) && flagBadgeRevenda,
    BadgeUberSP: isD2D ? false : shouldShowBadgeUberSP, // Desabilitado para D2D
    BadgeUberRJ: isD2D ? false : shouldShowBadgeUberRJ, // Desabilitado para D2D
    BadgeUberBoothStates: isD2D ? false : shouldShowBadgeUberBoothStates, // Desabilitado para D2D
    BadgePneus: isD2D ? false : shouldShowPneus, // Desabilitado para D2D
    BadgeInterior: isD2D ? false : shouldShowInterior, // Desabilitado para D2D
    BadgeGNV: shouldShowGNV,
    BadgeBlindagem: shouldShowBlindagem,
    BadgeMotor: shouldShowMotor,
  };

  const BADGES = [
    {
      icone: summary?.hasD2D ? CautelarInstaCarro : Cautelar,
      titulo: summary?.hasD2D ? 'Cautelar aprovada' : 'Cautelar aprovada',
      descricao: summary?.hasD2D
        ? 'Aprovada, pode conter apontamentos'
        : 'Cautelar Visão total verificada e aprovada',
    },
    {
      icone: Longarina,
      titulo: 'Longarina sem apontamentos',
      descricao: 'Verificada e sem observações',
    },
    {
      icone: Colunas,
      titulo: 'Colunas sem apontamentos',
      descricao: 'Verificadas e sem observações',
    },
    {
      icone: Km,
      titulo: 'Boa km por ano',
      descricao: 'Na média de km para carros do mesmo ano',
    },
    {
      icone: Cambio,
      titulo: 'Câmbio sem apontamentos',
      descricao: 'Teste inerte sem ressalvas',
    },
    {
      icone: Scanner,
      titulo: 'Scanner sem apontamentos',
      descricao: 'Verificado e sem observações',
    },
    {
      icone: Margem,
      titulo: 'Margem alta na revenda',
      descricao: '70% abaixo do preço da web',
    },
    {
      icone: Giro,
      titulo: 'Giro rápido',
      descricao: 'Mais vendidos segundo a Fenabrave',
    },
    {
      icone: UberSP,
      titulo: 'Aceito no Uber Black SP e outros',
      descricao:
        'Modelo autorizado para Uber Black em São Paulo, Brasília, Curitiba, Belo Horizonte e Porto Alegre',
    },
    {
      icone: UberRJ,
      titulo: 'Aceito no Uber Black RJ e outros',
      descricao:
        'Modelo autorizado para Uber Black no Rio de Janeiro, Campinas, Salvador, Recife, Florianópolis, Goiânia, Fortaleza e Vitória',
    },
    {
      icone: Uber,
      titulo: 'Aceito no Uber Black SP, RJ e outros',
      descricao:
        'Modelo autorizado para Uber Black em São Paulo, Brasília, Curitiba, Belo Horizonte, Porto Alegre, Rio de Janeiro, Salvador, Recife, Florianópolis, Goiânia, Fortaleza e Vitória',
    },
    {
      icone: BadgePneus, // Nova badge de pneus
      titulo: 'Pneus em condição de rodagem',
    },
    {
      icone: BadgeInterior, // Nova badge de conservação do interior
      titulo: 'Bom estado de conservação interior',
    },
    {
      icone: BadgeGNV, // Nova badge de GNV
      titulo: 'Equipado com GNV',
    },
    {
      icone: BadgeBlindagem, // Nova badge de blindagem
      titulo: 'Veículo blindado',
      descricao: 'Blindagem documentada',
    },
    {
      icone: BadgeMotor, // Badge de motor sem apontamentos
      titulo: 'Motor sem apontamentos',
      descricao: 'Teste inerte sem ressalvas',
    },
  ];

  const trueBadgesKeys = Object.keys(BADGE_STATUS).filter(key => BADGE_STATUS[key]);

  // Aplicar regras de supressão e ordenação
  const getOrderedBadges = () => {
    // Ordem de relevância conforme documento:
    // 1. ESTRUTURA: Cautelar, Longarina, Colunas, Boa km
    // 2. MECÂNICA: Motor, Câmbio, Scanner
    // 3. VISUAL: Interior
    // 4. EQUIPAMENTOS: Pneus, GNV
    // 5. PESQUISA: Blindagem
    // 6. MARGEM: Margem alta, Giro rápido
    // UBER: SP+RJ+outros, SP+outros, RJ+outros
    const badgeOrder = [
      // 1. ESTRUTURA
      'BadgeCautelar', // Cautelar aprovada
      'BadgeLongarina', // Longarina sem apontamentos
      'BadgeColunas', // Colunas sem apontamentos
      'BadgeBomKm', // Boa km por ano
      // 2. MECÂNICA
      'BadgeMotor', // Motor sem apontamentos
      'BadgeCambio', // Câmbio sem apontamentos
      'BadgeScanner', // Scanner sem apontamentos
      // 3. VISUAL
      'BadgeInterior', // Bom estado de conservação interior
      // 4. EQUIPAMENTOS
      'BadgePneus', // Pneus em condição de rodagem
      'BadgeGNV', // Equipado com GNV
      // 5. PESQUISA
      'BadgeBlindagem', // Veículo blindado
      // 6. MARGEM
      'BadgeMargem', // Margem alta na revenda
      'BadgeRevenda', // Giro rápido
      // UBER
      'BadgeUberBoothStates', // Aceito no Uber Black SP, RJ e outros
      'BadgeUberSP', // Aceito no Uber Black SP e outros
      'BadgeUberRJ', // Aceito no Uber Black RJ e outros
    ];

    // Aplicar regras de supressão
    let filteredBadges = Object.keys(BADGE_STATUS).filter(key => BADGE_STATUS[key]);

    // Regra 1: Se "Cautelar Aprovada" está presente, NÃO exibir "Longarina" e "Coluna"
    if (filteredBadges.includes('BadgeCautelar')) {
      filteredBadges = filteredBadges.filter(
        badge => !['BadgeLongarina', 'BadgeColunas'].includes(badge)
      );
    }

    // Regra 2: Se "Mecânica sem Avarias" (todas as mecânicas) está presente,
    // NÃO exibir badges mecânicas individuais
    const hasCambio = filteredBadges.includes('BadgeCambio');
    const hasScanner = filteredBadges.includes('BadgeScanner');

    if (hasCambio && hasScanner) {
      // Se tem ambas as badges mecânicas, criar uma badge geral "Mecânica sem avarias"
      // e remover as individuais
      filteredBadges = filteredBadges.filter(
        badge => !['BadgeCambio', 'BadgeScanner'].includes(badge)
      );
      // Adicionar badge geral (seria implementada separadamente se necessário)
      // filteredBadges.push('BadgeMecanicaSemAvarias');
    }

    // Ordenar badges pela ordem de prioridade definida
    const orderedBadges = badgeOrder.filter(badge => filteredBadges.includes(badge));

    // Adicionar badges que não estão na ordem definida (fallback)
    const remainingBadges = filteredBadges.filter(badge => !badgeOrder.includes(badge));
    return [...orderedBadges, ...remainingBadges];
  };

  // Mapeamento direto entre chaves de badge e índices no array BADGES
  const badgeIndexMap = {
    BadgeCautelar: 0,
    BadgeLongarina: 1,
    BadgeColunas: 2,
    BadgeBomKm: 3,
    BadgeCambio: 4,
    BadgeScanner: 5,
    BadgeMargem: 6,
    BadgeRevenda: 7,
    BadgeUberSP: 8,
    BadgeUberRJ: 9,
    BadgeUberBoothStates: 10,
    BadgePneus: 11,
    BadgeInterior: 12,
    BadgeGNV: 13,
    BadgeBlindagem: 14,
    BadgeMotor: 15,
  };

  const getTrueBadges = () => {
    const orderedBadges = getOrderedBadges();
    return orderedBadges.reduce((result, key) => {
      const badgeIndex = badgeIndexMap[key];
      if (badgeIndex !== undefined && BADGES[badgeIndex] && BADGES[badgeIndex].icone) {
        result[key] = BADGES[badgeIndex];
      }
      return result;
    }, {});
  };

  const badgesToDisplay = getTrueBadges();

  const getVersionByFuel = useCallback(() => {
    let matched;

    if (!summary?.version) {
      return '-';
    }

    fuel.forEach(f => {
      if (
        summary.version
          .normalize('NFD')
          .replace(/\p{Mn}/gu, '')
          .toUpperCase()
          .includes(f)
      ) {
        matched = f.charAt(0).toUpperCase() + f.slice(1).toLowerCase();

        if (matched === 'Eletrico') {
          matched = 'Elétrico';
        }

        if (matched === 'Hibrido' || matched === 'Hybrid') {
          matched = 'Híbrido';
        }

        if (matched === 'Hibrido flex' || matched === 'Hybrid flex') {
          matched = 'Híbrido/Flex';
        }

        if (matched === 'Jetflex gasolina') {
          matched = 'Gasolina';
        }
      }
    });

    const hasGNV =
      (summary?.summary && String(summary.summary).toUpperCase().includes('GNV')) ||
      (summary?.version && String(summary.version).toUpperCase().includes('GNV'));

    if (hasGNV) {
      return `${matched}/GNV`;
    }

    return matched || '-';
  }, [summary]);

  const getGear = useMemo(() => {
    if (summary?.version?.includes('MANUAL')) {
      return 'Manual';
    }

    return summary?.version?.includes('AUTOMATIZADO') ? 'Automatizado' : 'Automático';
  }, [summary]);

  window.addEventListener('resize', () => setSize(window.screen.width));

  return (
    <Container enabled={shouldShowFipeWebPrices}>
      <VehicleArea>
        {shouldShowFipeWebPrices && (
          <ReferencePrices
            marketPrice={marketPrice}
            webPrice={summary?.webPrice}
            spec={props?.spec}
          />
        )}

        {trueBadgesKeys.length > 0 && (
          <Column>
            <BadgeAreaTitle>Destaques da oferta</BadgeAreaTitle>
            <BadgeArea>
              {Object.entries(badgesToDisplay).map(([key, badge]) => (
                <Column key={key} inGrid>
                  <Badge>
                    <BadgeIcon src={badge.icone} />
                    <BadgeContent>
                      <BadgeTitle>{badge.titulo}</BadgeTitle>
                      {badge.descricao && <BadgeDescription>{badge.descricao}</BadgeDescription>}
                    </BadgeContent>
                  </Badge>
                  <Divider />
                </Column>
              ))}
            </BadgeArea>
          </Column>
        )}

        <Column>
          <BadgeAreaTitle>Informações gerais</BadgeAreaTitle>
        </Column>

        <Row>
          <Column>
            <List>
              <ListItem>
                <span>Ano</span>
                <strong>{summary?.year}</strong>
              </ListItem>
              <ListItem>
                <span>Km</span>
                <strong>
                  {summary?.km?.toLocaleString('pt-BR', { minimumFractionDigits: 0 })}
                </strong>
              </ListItem>
              <ListItem>
                <span>Câmbio</span>
                <strong>{getGear}</strong>
              </ListItem>
              <ListItem>
                <span>Combustível</span>
                <strong>{getVersionByFuel()}</strong>
              </ListItem>
              <ListItem>
                <span>Cautelar</span>
                <strong>{injuctionNote}</strong>
              </ListItem>
            </List>
          </Column>

          <Column>
            <List>
              <ListItem>
                <span>Final da Placa</span>
                <strong>{String(summary?.plateNumber).substring(7)}</strong>
              </ListItem>
              <ListItem>
                <span>Emplacado em</span>
                <strong>{summary?.additionalInfo?.registeredIn}</strong>
              </ListItem>
              <ListItem>
                <span>Manual</span>
                <strong>{summary?.additionalInfo?.hasManual}</strong>
              </ListItem>
              <ListItem>
                <span>Chave reserva</span>
                <strong>{summary?.additionalInfo?.hasKeySet}</strong>
              </ListItem>
            </List>
          </Column>
        </Row>
      </VehicleArea>
      <DutLabel>{updatedAuction?.summary?.documentResearch?.dutLabel}</DutLabel>
      {props?.evaluationComment?.[0]?.value?.length >= 1 && (
        <div className="evaluation-section" style={{ marginTop: '1.4rem' }}>
          <div style={{ fontSize: '1rem' }}>
            <span style={{ marginLeft: '0.5rem', fontWeight: 'bolder' }}>
              💬 {props?.evaluationComment?.label && `${props?.evaluationComment?.label}:  `}
            </span>
            {props?.evaluationComment?.value && ` ${props?.evaluationComment?.value}`}&nbsp;
            {props?.evaluationComment?.comment && ` - ${props?.evaluationComment?.comment}`}
          </div>
        </div>
      )}
    </Container>
  );
};
